import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { fetchCurrentUser, logoutUser } from "../api/userApi";
import { useUserStore } from "./store";

export const USER_QUERY_KEY = ["user", "current"] as const;

export function useCurrentUserQuery() {
  const setUser = useUserStore((state) => state.setUser);
  const setLoading = useUserStore((state) => state.setLoading);

  const query = useQuery({
    queryKey: USER_QUERY_KEY,
    queryFn: fetchCurrentUser,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (query.isLoading) {
      setLoading(true);
    } else {
      setUser(query.data ?? null);
    }
  }, [query.isLoading, query.data, setUser, setLoading]);

  return query;
}

export function useLogoutMutation() {
  const queryClient = useQueryClient();
  const clearUser = useUserStore((state) => state.clearUser);

  return useMutation({
    mutationFn: logoutUser,
    onSettled: () => {
      clearUser();
      queryClient.setQueryData(USER_QUERY_KEY, null);
      queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY });
    },
  });
}
